/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { parametersFilter } from '../models/parametersFilter';
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EnterprisesProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * returns a list of companies that belong to an enterprise
   * @param filter
   * @returns any successfully retrieved the list of companies for an enterprise
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesEnterprisesGetCompanies(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<{
      readonly uuid?: string;
      readonly createdAt?: string;
      readonly createdBy?: string;
      readonly lastUpdatedAt?: string;
      readonly lastUpdatedBy?: string;
      readonly lastUpdatedByAudience?: string;
      readonly lastUpdatedByAudienceUuid?: string;
      readonly lastUpdatedByImpersonatedBy?: string;
      readonly lastUpdatedByCompanyUuid?: string;
      readonly lastUpdatedByEnterpriseUuid?: string;
      name?: string;
      slug?: string;
      mainLogoUrl?: string;
      mainWebsiteUrl?: string;
      privacyPolicyUrl?: string;
      termsOfServiceUrl?: string;
      defaultBrandUuid?: string;
      address?: {
        address1?: string;
        address2?: string;
        city?: string;
        zip?: string;
        state?: string;
        country?: string;
      };
      /**
       * whether the portal has been configured at least once
       */
      hasSetupPortal?: boolean;
      /**
       * Optional metadata object containing self-serve account information and other additional fields.
       */
      metadata?: Record<string, any>;
      legalName?: string;
      /**
       * Employer identification number
       */
      ein?: string;
      /**
       * when the hire account was connected
       */
      readonly hireConnectedAt?: string | null;
      /**
       * Account UUID in Fountain Hire
       */
      hireAccountUuid?: string;
      /**
       * Account base URL in Fountain Hire
       */
      hireAccountBaseUrl?: string;
      /**
       * Account base URL for Fountain Go
       */
      hireGoAccountBaseUrl?: string;
      /**
       * Account Career Site base URL in Fountain Hire
       */
      careerSiteUrl?: string;
      /**
       * Account API key in Fountain Hire
       */
      hireAccountApiKey?: string;
      /**
       * Account Recruiter Base URL in Fountain Hire
       */
      hireAccountRecruiterBaseUrl?: string;
      /**
       * Account slug in Fountain Hire
       */
      hireAccountSlug?: string;
      /**
       * Contact email for workers needing additional assistance
       */
      supportEmail?: string;
      /**
       * Contact phone number for workers needing additional assistance
       */
      supportPhone?: string;
      /**
       * Customer-facing support URL
       */
      supportUrl?: string;
      /**
       * Email of the authorized representative for SMS brand registration
       */
      contactEmail?: string;
      /**
       * Phone number of the authorized representative for SMS brand registration
       */
      contactPhone?: string;
      /**
       * Alternative phone numbers for workers according to their hiring source
       */
      alternativeSupportPhones?: Array<{
        number: string;
        source: string;
      }>;
      /**
       * Enables or disables employer messaging functionality for Hire applicants
       */
      hireMessagingEnabled?: boolean;
      /**
       * Enables or disables employer messaging functionality for Workday candidates
       */
      workdayMessagingEnabled?: boolean;
      /**
       * Enables or disables automated data synchronization with Fountain Hire
       */
      enableHireDataSync?: boolean;
      /**
       * This company has a Fountain Hire Go account
       */
      hasHireGoAccount?: boolean;
      /**
       * This company uses unified authentication system
       */
      unifiedAuth?: boolean;
      /**
       * This company uses unified access system
       */
      unifiedAccess?: boolean;
      /**
       * If true, all users in this company need 2fa enabled
       */
      tfaRequired?: boolean;
      /**
       * Number of days before a worker is considered inactive and locked out of the system
       */
      inactivityLockDays?: number;
      /**
       * Password policy for employers in the company
       */
      passwordPolicy?: {
        /**
         * Minimum length of the password
         */
        minLength?: number;
        /**
         * Number of days before the password expires
         */
        expireAfterDays?: number;
      };
      portalOptions?: {
        enableMagicLink?: boolean;
        enableOtp?: boolean;
        enableUpdateContactInfo?: {
          firstname?: boolean;
          lastname?: boolean;
          personalEmail?: boolean;
          mobilePhone?: boolean;
        };
        enableSmsOptOut?: boolean;
      };
      companyType?: 'active' | 'internal' | 'pilot' | 'demo';
      /**
       * Lifecycle status mirrored from the Hire account. Only settable via the internal process endpoint.
       */
      accountStatus?: 'live' | 'paused' | 'churned';
      /**
       * Contact first name for SMS brand registration
       */
      contactFirstName?: string;
      /**
       * Contact last name for SMS brand registration
       */
      contactLastName?: string;
      /**
       * Industry vertical for SMS brand registration
       */
      vertical?: 'AGRICULTURE' | 'COMMUNICATION' | 'CONSTRUCTION' | 'EDUCATION' | 'ENERGY' | 'ENTERTAINMENT' | 'FINANCIAL' | 'GAMBLING' | 'GOVERNMENT' | 'HEALTHCARE' | 'HOSPITALITY' | 'HUMAN_RESOURCES' | 'INSURANCE' | 'LEGAL' | 'MANUFACTURING' | 'NGO' | 'POLITICAL' | 'POSTAL' | 'PROFESSIONAL' | 'REAL_ESTATE' | 'RETAIL' | 'TECHNOLOGY' | 'TRANSPORTATION';
      /**
       * Salesforce ID for the company
       */
      salesforceId?: string;
      /**
       * Indicates if this company was created through self-serve registration
       */
      selfServe?: boolean;
      /**
       * Free-form context notes about the company.
       */
      companyContext?: string;
      /**
       * IANA timezone identifier for the company (e.g. "America/Chicago"). Used to determine business hours for outbound worker actions.
       */
      timezone?: 'Pacific/Niue' | 'Pacific/Pago_Pago' | 'Pacific/Honolulu' | 'Pacific/Rarotonga' | 'Pacific/Tahiti' | 'Pacific/Marquesas' | 'America/Anchorage' | 'Pacific/Gambier' | 'America/Los_Angeles' | 'America/Tijuana' | 'America/Vancouver' | 'America/Whitehorse' | 'Pacific/Pitcairn' | 'America/Dawson_Creek' | 'America/Denver' | 'America/Edmonton' | 'America/Hermosillo' | 'America/Mazatlan' | 'America/Phoenix' | 'America/Yellowknife' | 'America/Belize' | 'America/Chicago' | 'America/Costa_Rica' | 'America/El_Salvador' | 'America/Guatemala' | 'America/Managua' | 'America/Mexico_City' | 'America/Regina' | 'America/Tegucigalpa' | 'America/Winnipeg' | 'Pacific/Galapagos' | 'America/Bogota' | 'America/Cancun' | 'America/Cayman' | 'America/Guayaquil' | 'America/Havana' | 'America/Iqaluit' | 'America/Jamaica' | 'America/Lima' | 'America/Nassau' | 'America/New_York' | 'America/Panama' | 'America/Port-au-Prince' | 'America/Rio_Branco' | 'America/Toronto' | 'Pacific/Easter' | 'America/Caracas' | 'America/Asuncion' | 'America/Barbados' | 'America/Boa_Vista' | 'America/Campo_Grande' | 'America/Cuiaba' | 'America/Curacao' | 'America/Grand_Turk' | 'America/Guyana' | 'America/Halifax' | 'America/La_Paz' | 'America/Manaus' | 'America/Martinique' | 'America/Port_of_Spain' | 'America/Porto_Velho' | 'America/Puerto_Rico' | 'America/Santo_Domingo' | 'America/Thule' | 'Atlantic/Bermuda' | 'America/St_Johns' | 'America/Araguaina' | 'America/Argentina/Buenos_Aires' | 'America/Bahia' | 'America/Belem' | 'America/Cayenne' | 'America/Fortaleza' | 'America/Godthab' | 'America/Maceio' | 'America/Miquelon' | 'America/Montevideo' | 'America/Paramaribo' | 'America/Recife' | 'America/Santiago' | 'America/Sao_Paulo' | 'Antarctica/Palmer' | 'Antarctica/Rothera' | 'Atlantic/Stanley' | 'America/Noronha' | 'Atlantic/South_Georgia' | 'America/Scoresbysund' | 'Atlantic/Azores' | 'Atlantic/Cape_Verde' | 'Africa/Abidjan' | 'Africa/Accra' | 'Africa/Bissau' | 'Africa/Casablanca' | 'Africa/El_Aaiun' | 'Africa/Monrovia' | 'America/Danmarkshavn' | 'Atlantic/Canary' | 'Atlantic/Faroe' | 'Atlantic/Reykjavik' | 'Etc/GMT' | 'Europe/Dublin' | 'Europe/Lisbon' | 'Europe/London' | 'Africa/Algiers' | 'Africa/Ceuta' | 'Africa/Lagos' | 'Africa/Ndjamena' | 'Africa/Tunis' | 'Africa/Windhoek' | 'Europe/Amsterdam' | 'Europe/Andorra' | 'Europe/Belgrade' | 'Europe/Berlin' | 'Europe/Brussels' | 'Europe/Budapest' | 'Europe/Copenhagen' | 'Europe/Gibraltar' | 'Europe/Ljubljana' | 'Europe/Luxembourg' | 'Europe/Madrid' | 'Europe/Malta' | 'Europe/Monaco' | 'Europe/Oslo' | 'Europe/Paris' | 'Europe/Prague' | 'Europe/Rome' | 'Europe/Stockholm' | 'Europe/Tirane' | 'Europe/Vienna' | 'Europe/Warsaw' | 'Europe/Zurich' | 'Africa/Cairo' | 'Africa/Johannesburg' | 'Africa/Maputo' | 'Africa/Tripoli' | 'Asia/Amman' | 'Asia/Beirut' | 'Asia/Damascus' | 'Asia/Gaza' | 'Asia/Jerusalem' | 'Asia/Nicosia' | 'Europe/Athens' | 'Europe/Bucharest' | 'Europe/Chisinau' | 'Europe/Helsinki' | 'Europe/Istanbul' | 'Europe/Kaliningrad' | 'Europe/Kyiv' | 'Europe/Riga' | 'Europe/Sofia' | 'Europe/Tallinn' | 'Europe/Vilnius' | 'Africa/Khartoum' | 'Africa/Nairobi' | 'Antarctica/Syowa' | 'Asia/Baghdad' | 'Asia/Qatar' | 'Asia/Riyadh' | 'Europe/Minsk' | 'Europe/Moscow' | 'Asia/Tehran' | 'Asia/Baku' | 'Asia/Dubai' | 'Asia/Tbilisi' | 'Asia/Yerevan' | 'Europe/Samara' | 'Indian/Mahe' | 'Indian/Mauritius' | 'Indian/Reunion' | 'Asia/Kabul' | 'Antarctica/Mawson' | 'Asia/Aqtau' | 'Asia/Aqtobe' | 'Asia/Ashgabat' | 'Asia/Dushanbe' | 'Asia/Karachi' | 'Asia/Tashkent' | 'Asia/Yekaterinburg' | 'Indian/Kerguelen' | 'Indian/Maldives' | 'Asia/Calcutta' | 'Asia/Colombo' | 'Asia/Katmandu' | 'Antarctica/Vostok' | 'Asia/Almaty' | 'Asia/Bishkek' | 'Asia/Dhaka' | 'Asia/Omsk' | 'Asia/Thimphu' | 'Indian/Chagos' | 'Asia/Rangoon' | 'Indian/Cocos' | 'Antarctica/Davis' | 'Asia/Bangkok' | 'Asia/Hovd' | 'Asia/Jakarta' | 'Asia/Krasnoyarsk' | 'Asia/Saigon' | 'Asia/Ho_Chi_Minh' | 'Indian/Christmas' | 'Antarctica/Casey' | 'Asia/Brunei' | 'Asia/Choibalsan' | 'Asia/Hong_Kong' | 'Asia/Irkutsk' | 'Asia/Kuala_Lumpur' | 'Asia/Macau' | 'Asia/Makassar' | 'Asia/Manila' | 'Asia/Shanghai' | 'Asia/Singapore' | 'Asia/Taipei' | 'Asia/Ulaanbaatar' | 'Australia/Perth' | 'Asia/Pyongyang' | 'Asia/Dili' | 'Asia/Jayapura' | 'Asia/Seoul' | 'Asia/Tokyo' | 'Asia/Yakutsk' | 'Pacific/Palau' | 'Australia/Adelaide' | 'Australia/Darwin' | 'Antarctica/DumontDUrville' | 'Asia/Magadan' | 'Asia/Vladivostok' | 'Australia/Brisbane' | 'Asia/Sakhalin' | 'Australia/Hobart' | 'Australia/Sydney' | 'Pacific/Chuuk' | 'Pacific/Guam' | 'Pacific/Port_Moresby' | 'Pacific/Efate' | 'Pacific/Guadalcanal' | 'Pacific/Kosrae' | 'Pacific/Norfolk' | 'Pacific/Noumea' | 'Pacific/Pohnpei' | 'Asia/Kamchatka' | 'Pacific/Auckland' | 'Pacific/Fiji' | 'Pacific/Funafuti' | 'Pacific/Kwajalein' | 'Pacific/Majuro' | 'Pacific/Nauru' | 'Pacific/Tarawa' | 'Pacific/Wake' | 'Pacific/Wallis' | 'Pacific/Apia' | 'Pacific/Enderbury' | 'Pacific/Fakaofo' | 'Pacific/Tongatapu' | 'Pacific/Kiritimati' | 'UTC';
      /**
       * Per-product freemium access flags (internal only)
       */
      freemiumProducts?: {
        pool?: {
          /**
           * Whether Pool freemium is enabled for this company
           */
          enabled?: boolean;
        };
      };
    }>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/enterprises/getCompanies',
      query: {
        'filter': filter,
      },
    });
  }

  /**
   * creates a new company in the caller enterprise and invites the first employer user
   * Creates a new WX company attached to the caller enterprise via the same Hire provisioning path as the public self-serve signup. Sends the first employer user a password-setup email. The enterprise attachment is taken from the caller JWT, not the request body.
   * @param requestBody
   * @returns any Company successfully created
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesEnterprisesCreateCompany(
    requestBody: {
      /**
       * Name of the new company
       */
      company_name: string;
      /**
       * Full name of the first employer user to invite
       */
      owner_name: string;
      /**
       * Business email of the first employer user
       */
      owner_email: string;
      /**
       * ISO 3166-1 alpha-2 country code
       */
      country: string;
      /**
       * Optional company domain
       */
      company_domain?: string;
    },
  ): CancelablePromise<{
    data?: {
      success?: boolean;
      account?: {
        id?: string;
        name?: string;
        slug?: string;
      };
      company?: {
        uuid?: string;
        name?: string;
      };
      region?: string;
      ownerFound?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/enterprises/createCompany',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
